import {KecPath, Service, Version, source} from './constants';

// 启动模板列表
export const startTempList = {
    basePath: KecPath,
    method: 'post',
    params: {
        Action: 'DescribeModels',
        Service,
        Version,
        source
    }
};

//删除云服务器
export const deleteStartTemp = {
    basePath: KecPath,
    method: 'post',
    params: {
        Action: 'TerminateModels',
        Service,
        Version,
        source
    }
};

//修改实例启动模板名称
export const modifyModel = {
    basePath: KecPath,
    params: {
        Action: 'CreateModelVersion',
        Service,
        Version,
        source
    },
    method: 'post'
};

//修改实例启动模板名称
export const ModifyDefaultVersion = {
    basePath: KecPath,
    params: {
        Action: 'ModifyDefaultVersion',
        Service,
        Version,
        source
    },
    method: 'post'
};